module.exports = __webpack_public_path__ + "static/media/image-tanya.343537c1.jpg";